import { heroFeature, heroSideCards, quickEntries } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="px-4 pb-14 pt-10 md:px-6 md:pb-16 md:pt-14 lg:px-8">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
              <span className="hl-pulse-dot h-1.5 w-1.5 rounded-full bg-primary-500" />
              黑料51瓜友正在热议
            </span>
            <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
              黑料51
              <span className="text-primary-600">·</span>
              吃瓜群众的聚集地
            </h1>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              这里是黑料51瓜友共同的瓜田：每日更新热门事件内幕与深度爆料，吃瓜群众可以畅快讨论、实时追踪话题焦点。
              我们只做一件事——把散落的公开线索按顺序摆好，帮你快速掌握事件脉络，不错过任何精彩瞬间。
            </p>
          </div>

          <div className="flex flex-wrap gap-2 lg:justify-end">
            {quickEntries.map((entry) => (
              <a
                key={entry.href}
                href={entry.href}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
              >
                <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                  <i className={`${entry.icon} text-base`} />
                </span>
                {entry.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-12">
          <a
            href="#latest"
            className="hl-fade-up group relative block overflow-hidden rounded-lg border border-background-200 lg:col-span-7"
          >
            <div className="relative h-[280px] w-full overflow-hidden md:h-[400px]">
              <img
                src={heroFeature.image}
                alt="黑料51 独家线索配图"
                title="黑料51独家线索 片场换角风波"
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/10" />
            </div>
            <div className="absolute left-0 top-0 flex items-center gap-2 p-5">
              <span className="rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                {heroFeature.tag}
              </span>
              <span className="inline-flex items-center gap-1 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-primary-700">
                <span className="flex h-3 w-3 items-center justify-center">
                  <i className="ri-fire-line text-xs" />
                </span>
                热度 {heroFeature.heat}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 w-full p-5 md:p-6">
              <h3 className="font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                {heroFeature.title}
              </h3>
              <p className="mt-3 line-clamp-2 max-w-xl text-sm leading-relaxed text-background-100/90">
                {heroFeature.summary}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-xs text-background-100/80">
                <span className="whitespace-nowrap">{heroFeature.time}</span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap">
                  <span className="flex h-3 w-3 items-center justify-center">
                    <i className="ri-chat-3-line text-xs" />
                  </span>
                  {heroFeature.comments} 条讨论
                </span>
                <span className="inline-flex items-center gap-1 font-semibold text-accent-300">
                  查看时间线
                  <span className="flex h-3 w-3 items-center justify-center">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </span>
              </div>
            </div>
          </a>

          <div className="flex flex-col gap-5 lg:col-span-5">
            {heroSideCards.map((card, index) => (
              <a
                key={card.id}
                href="#latest"
                style={{ animationDelay: `${0.1 + index * 0.08}s` }}
                className="hl-fade-up group flex flex-1 overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-200"
              >
                <div className="relative h-full w-32 shrink-0 overflow-hidden sm:w-40">
                  <img
                    src={card.image}
                    alt={`黑料51 ${card.title}`}
                    title={`黑料51 ${card.title}`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center gap-2 p-4 md:p-5">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-secondary-100 px-2 py-0.5 text-[11px] font-bold text-secondary-900">
                      {card.tag}
                    </span>
                    <span className="text-[11px] font-medium text-foreground-500">{card.time}</span>
                  </div>
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                    {card.title}
                  </h3>
                  <p className="line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {card.summary}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                    <span className="flex h-3 w-3 items-center justify-center">
                      <i className="ri-fire-line text-xs" />
                    </span>
                    {card.heat}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}